import type { Client } from '@hey-api/client-fetch'
import { injectLocal, isDefined } from '@vueuse/core'

export const ApiClientInjectionKey = Symbol('api-client')
export function useApiClient(): (accessToken: string | null) => Client {
  const apiClient = injectLocal<(accessToken: string | null) => Client>(ApiClientInjectionKey)
  if (!isDefined(apiClient)) {
    throw new Error('Api client could not be determined')
  }
  return apiClient
}
